function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { decodeHtmlEntities } from '../../common/utils';
export var IlcConfigRoot = /*#__PURE__*/function () {
  function IlcConfigRoot() {
    var _registryConfiguratio;
    _classCallCheck(this, IlcConfigRoot);
    var ilcConfigurationNode = document.querySelector('script[type="text/ilc-config"]');
    if (ilcConfigurationNode === null) {
      throw new Error("Can't find single-spa configuration node. Looks like server side problem occurs.");
    }
    var registryConfiguration = JSON.parse(ilcConfigurationNode.innerHTML);
    var customHTML = (_registryConfiguratio = registryConfiguration.settings) === null || _registryConfiguratio === void 0 || (_registryConfiguratio = _registryConfiguratio.globalSpinner) === null || _registryConfiguratio === void 0 ? void 0 : _registryConfiguratio.customHTML;
    if (customHTML) {
      registryConfiguration.settings.globalSpinner.customHTML = decodeHtmlEntities(customHTML);
    }
    this.registryConfiguration = registryConfiguration;
  }
  return _createClass(IlcConfigRoot, [{
    key: "getConfig",
    value: function getConfig() {
      return this.registryConfiguration;
    }
  }, {
    key: "getConfigForApps",
    value: function getConfigForApps() {
      return this.registryConfiguration['apps'];
    }
  }, {
    key: "getConfigForAppByName",
    value: function getConfigForAppByName(name) {
      return this.registryConfiguration['apps'][name];
    }

    /**
     *
     * @param name
     * @description Checks if application is clientless by name. Clientless app is an app w/o clientside bundle. So it renders only on backend side.
     * @returns {boolean}
     */
  }, {
    key: "isApplicationClientlessByAppName",
    value: function isApplicationClientlessByAppName(name) {
      if (!this.registryConfiguration['apps'][name]) {
        throw new Error("Application with name ".concat(name, " is not registered in ILC"));
      }
      return !this.registryConfiguration['apps'][name].spaBundle;
    }

    // @Deprecated. Config for shared lib was designed in non extensible format.
    // Next Major release it will require breaking change to return configuration object
  }, {
    key: "getConfigForSharedLibs",
    value: function getConfigForSharedLibs() {
      return this.registryConfiguration['sharedLibs'];
    }
  }, {
    key: "getConfigForSharedLibsByName",
    value: function getConfigForSharedLibsByName(name) {
      return this.registryConfiguration['dynamicLibs'][name];
    }
  }, {
    key: "getSettings",
    value: function getSettings() {
      return this.registryConfiguration['settings'];
    }
  }, {
    key: "getSettingsByKey",
    value: function getSettingsByKey(key) {
      return this.registryConfiguration['settings'][key];
    }
  }, {
    key: "isGlobalSpinnerEnabled",
    value: function isGlobalSpinnerEnabled() {
      var globalSpinnerConfig = this.getSettingsByKey('globalSpinner');
      var isEnabled = globalSpinnerConfig && globalSpinnerConfig.enabled;
      return !!isEnabled;
    }
  }, {
    key: "getConfigForRoutes",
    value: function getConfigForRoutes() {
      return this.registryConfiguration['routes'];
    }
  }, {
    key: "getConfigForSpecialRoutes",
    value: function getConfigForSpecialRoutes() {
      return this.registryConfiguration['specialRoutes'] || {};
    }

    /**
     *
     * @param {string} key
     * @return {object}
     */
  }, {
    key: "getConfigForSpecialRoutesByKey",
    value: function getConfigForSpecialRoutesByKey(key) {
      var specialRoute = this.getConfigForSpecialRoutes();
      return specialRoute[key];
    }
  }]);
}();
export var ilcConfigRoot = new IlcConfigRoot();